export default "__VITE_ASSET__Duw1T1p3__"